import React from 'react';
import PropTypes from 'prop-types';
import './Step.less';
import StepIcon from './StepIcon'
import StepConnector from './StepConnector'

function Step({id, label, status, number, hasConnector}) {
  return (
    <div className='Step' key={`Step--${id}`}>
      <StepIcon status={status} number={number}/>
      <div className={`Step__label Step__label--${status}`}>
        {label}
      </div>
      {hasConnector &&
      <StepConnector status={status}/>
      }
    </div>
  );
}

Step.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
  hasConnector: PropTypes.bool.isRequired
};

export default Step;
